module.exports = __webpack_public_path__ + "img/identify04.c0956876.png";